import { TextField } from "@mui/material";
import * as React from "react";
import {
  getuserDataBalanceAdmin,
  updateUserBalance,
} from "../../../config/services";

export const UpdateBalanceInput = ({ id }) => {
  const type = "savings";
  const [currentbalance, setCurrentbalance] = React.useState(0);
  const [values, setValues] = React.useState(0);

  React.useEffect(() => {
    const subscribeUserbalance = getuserDataBalanceAdmin(id, type).subscribe(
      (data) => {
        setValues(data.balance);
        console.log(data);
      }
    );

    return () => {
      subscribeUserbalance.unsubscribe();
    };
  }, []);

 

  const updatebalance = () => {
    
    updateUserBalance(id, type, parseInt(values)).then(() => {
      console.log("Balance updated");
    });
  };

  return (
    <form>
      <TextField
        fullWidth
        id="amount-local"
        label="Balance"
        type="amount-local"
        value={values}
        onChange={(event) => {
          setValues(event.target.value);
        }}
        onBlur={updatebalance}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </form>
  );
};
